/*
BEGIN MACRO
    NAME=ENDPATH
END MACRO
*/

export default class ENDPATH {
	toMacro() {
		return `
BEGIN MACRO
\tNAME=ENDPATH
END MACRO
`;
	}
}

